import { useQuery } from '@tanstack/react-query';
import { Contact } from '../../../types/Contact';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchContact = async (uuid: string, template?: string) => {
  const config = template ? { params: { template } } : {};
  const response = await CustomAxios.get<Contact>(`contacts/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetContactByIdProps {
  uuid: string;
  template?: string;
}
export function useGetContactById({ uuid, template }: UseGetContactByIdProps) {
  const queryKey = [queryKeys.allContacts, uuid];
  if (template) {
    queryKey.push(template);
  }
  const query = useQuery({
    queryKey: queryKey,
    queryFn: () => fetchContact(uuid, template),
  });

  return query;
}
